ui-cms-social-follow-links {
  display: block;
  width: 100%;
}
